import React, { useContext, useState, useImperativeHandle, forwardRef } from "react";
import { Drawer, List, ListItem, ListItemText, Button, IconButton, Box, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Menu, Close, Dashboard, Map, Person, Help } from "@mui/icons-material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { getMultipleShipment } from "../services/api"
// import Navigation from "../pages/gps/Navigator";


const Sidebar = forwardRef((_, ref) => {
    const { auth, logout, username } = useContext(AuthContext);
    const [open, setOpen] = useState(false);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    // Expose toggleDrawer function to the parent component
    useImperativeHandle(ref, () => ({
        toggleDrawer
    }));


    return (
        <Box sx={{ display: "flex" }}>
            {/* Menu Icon to Open Sidebar (Shows When Sidebar is Closed) */}
            {!open && (
                <IconButton
                    onClick={toggleDrawer}
                    sx={{
                        position: "fixed",
                        top: 20,
                        left: 20,
                        backgroundColor: "#ffffff",
                        boxShadow: "2px 2px 10px rgba(0,0,0,0.2)",
                        zIndex: 1300,
                    }}
                >
                    <Menu />
                </IconButton>
            )}

            {/* Sidebar Drawer */}
            <Drawer
                variant="persistent"
                anchor="left"
                open={open}
                sx={{
                    width: open ? 250 : 0,
                    transition: "width 0.3s ease-in-out",
                    "& .MuiDrawer-paper": {
                        width: open ? 250 : 0,
                        transition: "width 0.3s ease-in-out",
                        overflowX: "hidden",
                        boxShadow: "2px 0 5px rgba(0,0,0,0.2)", // Right-side box shadow
                        display: open ? "block" : "none", // Hide content when closed
                    },
                }}
            >
                {/* Sidebar Header with Close Button */}
                <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
                    <IconButton onClick={toggleDrawer}>
                        <Close />
                    </IconButton>
                </Box>

                {/* Sidebar List Items */}
                <List>
                    <ListItem
                        button
                        component={Link}
                        to={username === "telnet" ? "/dashboard" : "/gps-map"}                    >
                        <Dashboard sx={{ mr: 1 }} />
                        {/* <ListItemText primary={username === "telnet" ? "Dashboard" : "GPS Map"} /> */}
                        <ListItemText primary="Dashboard"/>
                    </ListItem>

                    {/* <ListItem button component={Link} to="/navigator-panel">
                        <Dashboard sx={{ mr: 1 }} />
                        <ListItemText primary="Navigator" />
                    </ListItem> */}
                    {/* <ListItem button component={Link} to="/create-shipment">
                        <LocalShippingIcon sx={{ mr: 1 }} />
                        <ListItemText primary="Create Shipment" />
                    </ListItem> */}
                    {/* <ListItem button component={Link} to="/profile">
                        <Person sx={{ mr: 1 }} />
                        <ListItemText primary="Profile" />
                    </ListItem>
                    <ListItem button component={Link} to="/gps">
                        <Map sx={{ mr: 1 }} />
                        <ListItemText primary="GPS Map" />
                    </ListItem>
                    <ListItem button component={Link} to="/dashboard">
                        <Map sx={{ mr: 1 }} />
                        <ListItemText primary="Old Dashboard" />
                    </ListItem>
                    
                    <ListItem button onClick={() => getMultipleShipment(auth)}>
                        <LocalShippingIcon sx={{ mr: 1 }} /> 
                        <ListItemText primary="Create s" />
                    </ListItem> */}

                </List>

                {/* Spacer to Push Help & Logout to Bottom */}
                <Box sx={{ flexGrow: 1 }} />

                <Divider />

                {/* Help Button */}
                {/* <List>
                    <ListItem button component={Link} to="/help">
                        <Help sx={{ mr: 1 }} />
                        <ListItemText primary="Help" />
                    </ListItem>
                </List> */}

                {/* Logout Button (Stuck to Bottom) */}
                <Box sx={{ p: 2 }}>
                    <Button fullWidth variant="contained" color="secondary" onClick={logout}>
                        Logout
                    </Button>
                </Box>
            </Drawer>
        </Box >
    );
});

export default Sidebar;
